// extracted by mini-css-extract-plugin
module.exports = {"button":"outline-mono-module--button--HtYAX","disabled":"outline-mono-module--disabled--FBxjg"};